import { styled } from '@mui/material/styles';
import { ToggleButton } from '@mui/material';
import type { ToggleButtonProps } from '@mui/material';

interface MenuLinkProps extends ToggleButtonProps {
  textcase?: 'lowercase' | 'uppercase' | 'capitalize' | 'none';
}

/** Pill-shaped navigation link used in the red header bar. */
const MenuLink = styled(ToggleButton, {
  shouldForwardProp: (prop) => prop !== 'textcase',
})<MenuLinkProps>(({ textcase = 'none' }) => ({
  color: '#ffffff',
  textTransform: textcase,
  fontSize: '16px',
  backgroundColor: 'transparent',
  fontFamily: 'SparkasseWeb',
  height: '38px',
  borderRadius: '19px',
  border: 'none',
  whiteSpace: 'nowrap',
  padding: '7px 24px',
  '&:hover': {
    backgroundColor: '#B60000',
    color: '#ffffff',
  },
  '&:active': {
    backgroundColor: '#B60000',
  },
  '&.Mui-selected': {
    backgroundColor: '#B60000',
    color: '#ffffff',
    border: 'none',
    '&:hover': {
      backgroundColor: '#B60000',
    },
  },
}));

export default MenuLink;
